import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../../styles/assets/css/pages/dashboard.css'

import Graph2 from './graph2.jsx'
import Tracker from './tracker.jsx'
import ScheduledAssessments from './scheduled_assessments.jsx'
import TreatmentGoals from './treatment_goals.jsx'
import ToDoList from './to_do_list.jsx'
import UpcomingAppointment from './upcoming_appointment.jsx'
//import PatientContract from './patient_contract.jsx'
import Worksheet from './worksheets.jsx'
import Badges from './badges.jsx'
import DashboardTrackSection from './dashboard_track_section.jsx'
import axios from 'axios'
import { connectNode } from '../../../utils/global'

class Dashboard extends Component {
  constructor() {
    super()
    this.state = {
      update_graph: 0,
      isMobile: window.innerWidth <= 768,
    }
    this.dashboardOpenedAt = Date.now()
    this.sessionId = this.createDashboardSessionId()
  }

  componentDidMount() {
    this.dashboardOpenedAt = Date.now()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  createDashboardSessionId = () => {
    const randomPart = Math.random()
      .toString(36)
      .substring(2, 12)

    return `${Date.now()}-${randomPart}`
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= 768
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
  }

  handleUpdateTracker = (val) => {
    if(val == 9) {
      this.setState({
        update_graph: Date.now(),
      })
    }
  }

  handleSectionReached = sectionData => {
    const millisecondsFromDashboardOpen = Date.now() - this.dashboardOpenedAt

    const trackingData = {
      pid: this.props.authReducer.uid,
      page_name: 'patient_dashboard',
      action_name: 'section_reached',
      section_name: sectionData.section_name,
      session_id: this.sessionId,
      platform: window.innerWidth <= 768 ? 'mobile_web' : 'desktop_web',
      visibility_percent: sectionData.visibility_percent,
      minimum_view_time_ms: sectionData.minimum_view_time_ms,
      milliseconds_from_page_open: millisecondsFromDashboardOpen,
      reached_at: new Date().toISOString(),
    }

    this.saveActivityLog(trackingData)
  }

  handleGraphFilterChange = filterData => {
    const trackingData = {
      pid: this.props.authReducer.uid,
      session_id: this.sessionId,
      page_name: 'patient_dashboard',
      section_name: 'graph',
      action_name: 'filter_change',
      platform: window.innerWidth <= 768 ? 'mobile_web' : 'desktop_web',
      reached_at: new Date().toISOString(),
      milliseconds_from_page_open: Date.now() - this.dashboardOpenedAt,
      metadata: {
        filter_name: filterData.filter_name,
        previous_value: filterData.previous_value,
        selected_value: filterData.selected_value,
        selected_label: filterData.selected_label,
      },
    }

    this.saveActivityLog(trackingData)
  }

  saveActivityLog = trackingData => {
    axios({
      method: 'post',
      url:
        connectNode +
        'patient/tracker/track_patient_dashboard',

      headers: {
        Accept: 'application/json',
        'Content-Type':
          'application/json;charset=UTF-8',
      },
      data: trackingData,
    })
      .then(result => {
        //console.log( 'Dashboard section reached:', trackingData.section_name )
      })
      .catch(error => {
        //console.log( 'Dashboard tracking error:', error )
      })
  }

  render() {
    const { isMobile, update_graph } = this.state
    const { authReducer } = this.props

    return (
      <div
        className="patient_dashboard"
        data-equalizer="dashboard"
      >
        {authReducer.p_st == 6 && (
          <div>
            {/* Trackers */}
            <DashboardTrackSection
              sectionName="trackers"
              threshold={0.25}
              minimumViewTime={1000}
              onSectionReached={
                this.handleSectionReached
              }
            >
              <Tracker
                onUpdateTracker={
                  this.handleUpdateTracker
                }
              />
            </DashboardTrackSection>

            {/* Mobile Graph */}
            {isMobile && (
              <DashboardTrackSection
                sectionName="graph"
                threshold={0.25}
                minimumViewTime={1500}
                onSectionReached={
                  this.handleSectionReached
                }
              >
                <div className="small-12 columns box_border box_space_top1">
                  <Graph2 pid={authReducer.uid} update_graph={update_graph}
                    onFilterChange={this.handleGraphFilterChange} />
                </div>
              </DashboardTrackSection>
            )}

            {/* Right column */}
            <div className="small-12 medium-5 columns right_db no_padding_right">
              <DashboardTrackSection
                sectionName="badges"
                threshold={0.25}
                minimumViewTime={1000}
                onSectionReached={this.handleSectionReached}
              >
                <Badges />
              </DashboardTrackSection>

              <ScheduledAssessments />

              <DashboardTrackSection
                sectionName="treatment_goals"
                threshold={0.25}
                minimumViewTime={1000}
                onSectionReached={this.handleSectionReached}
              >
                <TreatmentGoals />
              </DashboardTrackSection>

              <DashboardTrackSection
                sectionName="treatment_todo_list"
                threshold={0.25}
                minimumViewTime={1000}
                onSectionReached={this.handleSectionReached}
              >
                <ToDoList />
              </DashboardTrackSection>

              <UpcomingAppointment />
              <Worksheet />
            </div>

            {/* Desktop Graph */}
            {!isMobile && (
              <DashboardTrackSection
                sectionName="graph"
                threshold={0.15}
                minimumViewTime={1000}
                onSectionReached={this.handleSectionReached}
                className="small-12 columns box_border box_space_top1"
              >
                <Graph2 pid={authReducer.uid} update_graph={update_graph}
                  onFilterChange={this.handleGraphFilterChange} />
              </DashboardTrackSection>
            )}
          </div>
        )}

        {authReducer.p_st != 6 && (
          <div className="not_available box_border">
            Dashboard will be available after you have completed your intake appointment.
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
